import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { OutputFareConditionsPerPtc } from '@common/interfaces';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-plan-review-fare-conditions-per-ptc',
  templateUrl: './plan-review-fare-conditions-per-ptc.component.html',
  styleUrls: ['./plan-review-fare-conditions-per-ptc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanReviewFareConditionsPerPtcComponent extends SupportComponent {
  /** プラン有効判定 */
  @Input() isPlanValid = false;

  /** プロモーション適用フラグ */
  public isPromoApplied = false;

  /** 画面出力用運賃ルール情報 */
  @Input()
  set data(value: OutputFareConditionsPerPtc) {
    this._data = value;
    this.refresh();
  }
  get data(): OutputFareConditionsPerPtc {
    return this._data;
  }
  private _data: OutputFareConditionsPerPtc = {
    ptc: '',
    displayPtcName: '',
    bounds: [],
  };

  /** 横スクロール可否判定 */
  public isScroll = false;

  constructor(private _common: CommonLibService, private _changeDetectorRef: ChangeDetectorRef) {
    super(_common);
  }

  refresh(): void {
    this.isPromoApplied = this.data.bounds.some((bound) => bound.promo);
    this._changeDetectorRef.markForCheck();
  }

  reload(): void {}
  init(): void {}

  destroy(): void {}

  /**
   * スクロール有無設定処理
   * ※asw-table-sliderから受け取った値を設定するために使用
   * @param value
   */
  setIsScroll(value: boolean) {
    this.isScroll = value;
  }
}
